var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:`text-center ${!_vm.order ? 'sorting' : `sorting_${_vm.order}`} `,style:(`cursor:pointer;${_vm.width ? `width: ${_vm.width}%` : ''}`),on:{"click":_vm.changeOrder}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }